/* mm-warenkorb-upcart.js — der Warenkorb ist IMMER Upcart.
 *
 * 29.08.2026, Mert: "Immer wenn ich zum Warenkorb druecken moechte, kommt der
 * alte Warenkorb. Aber ich moechte nicht den alten Warenkorb. Ich moechte fuer
 * immer, also immer, egal was mit Warenkorb zu tun hat, soll der Warenkorb von
 * Upcart kommen."
 *
 * WAS HIER PASSIERT
 * Das Theme (Savor) bringt eine eigene Schublade mit. Der Knopf im Kopf traegt
 * `on:click="#cart-drawer/toggle"` und spricht damit das Element
 * `<theme-drawer id="cart-drawer">` an - ganz ohne Adresse, also greift kein
 * Umleiten ueber Links. Upcart haengt daneben und wird nur beim Hinzufuegen
 * aufgerufen, nicht beim Draufdruecken.
 *
 * Zwei Sicherungen, damit wirklich nichts mehr durchrutscht:
 *   1. JEDER Klick auf etwas Warenkorb-Artiges wird in der Auffangphase
 *      abgefangen - also bevor das Theme ihn sieht - und stattdessen Upcart
 *      geoeffnet. Auffangphase + `stopImmediatePropagation` ist der einzige
 *      Weg, der auch bei Handlern greift, die das Theme direkt am Element
 *      registriert hat.
 *   2. Sollte die alte Schublade doch aufgehen (etwa aus Theme-eigenem Code
 *      oder einer App), wird das bemerkt, sie wird sofort geschlossen und
 *      Upcart geoeffnet. Guertel und Hosentraeger.
 *
 * Bewusst NICHT angetastet: die Seite `/cart` selbst. Wer sie direkt aufruft
 * oder ohne JavaScript unterwegs ist, bekommt weiter eine funktionierende
 * Warenkorbseite - sonst waere der Shop fuer diese Faelle kaputt.
 */
(function () {
  'use strict';

  /* 02.09.2026, Mert: „Bei Upcart muss das Produktbild abgerundet sein wie
     zuvor auch."
     Im Theme gab es dafuer nie eine Regel - die Rundung kam aus Upcarts eigenen
     Einstellungen und ist dort verlorengegangen. Statt in der App zu suchen
     (ihre Oberflaeche laeuft in einem eingebetteten Rahmen, in dem Klicks nicht
     ankommen) steht die Rundung jetzt hier: sie trifft jedes Bild innerhalb
     eines Upcart-Bausteins, unabhaengig von dessen genauem Klassennamen -
     Upcart benennt seine Klassen zwischen Versionen um.
     `overflow:hidden` am Elternteil sorgt dafuer, dass auch ein Bild rund
     bleibt, das seinen Rahmen ausfuellt. */
  (function eckenRunden() {
    if (document.getElementById('mm-upcart-ecken')) return;
    var s = document.createElement('style');
    s.id = 'mm-upcart-ecken';
    s.textContent = [
      '[class*="upcart"] img,',
      '[class*="upCart"] img,',
      '#upCart img{border-radius:12px!important}',
      '[class*="upcart"] [class*="image"],',
      '[class*="upcart"] [class*="Image"]{border-radius:12px!important;overflow:hidden!important}'
    ].join('');
    (document.head || document.documentElement).appendChild(s);
  })();


  var SCHUBLADE = 'cart-drawer';

  /* Alles, was "Warenkorb aufmachen" bedeutet. Bewusst weit gefasst - lieber
     ein Treffer zu viel als der alte Kasten. */
  var AUSLOESER = [
    '[aria-controls="' + SCHUBLADE + '"]',
    '[on\\:click="#' + SCHUBLADE + '/toggle"]',
    '[on\\:click="#' + SCHUBLADE + '/showDialog"]',
    '[data-cart-drawer-toggle]',
    '.header-actions__cart',
    '.cart-bubble',
    'a[href$="/cart"]',
    'a[href$="/cart/"]',
    'a[href*="/cart?"]'
  ].join(',');

  function upcartDa() {
    return typeof window.upcartOpenCart === 'function';
  }

  function upcartOeffnen() {
    if (!upcartDa()) return false;
    try { window.upcartOpenCart(); return true; } catch (e) { return false; }
  }

  function alteZu() {
    var d = document.getElementById(SCHUBLADE);
    if (!d) return;
    try { if (typeof d.close === 'function') d.close(); } catch (e) {}
    var dlg = d.querySelector('dialog');
    if (dlg && dlg.open) { try { dlg.close(); } catch (e) {} }
  }

  /* --- Sicherung 1: Klicks abfangen, bevor das Theme sie sieht --- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var ziel = e.target.closest(AUSLOESER);
    if (!ziel) return;

    /* "In den Warenkorb" ist kein Oeffnen-Klick - das macht Upcart schon
       selbst ueber seinen eigenen Haken. Nicht doppelt anfassen. */
    if (e.target.closest('form[action*="/cart/add"]')) return;
    /* Innerhalb von Upcart selbst nichts kapern. */
    if (e.target.closest('#upCart')) return;

    /* Ist Upcart (noch) nicht da, laeuft alles wie bisher weiter. Lieber der
       alte Warenkorb als gar keiner. */
    if (!upcartDa()) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    upcartOeffnen();
  }, true);

  /* --- Sicherung 2: geht die alte Schublade doch auf, sofort umschalten --- */
  function wache() {
    var d = document.getElementById(SCHUBLADE);
    if (!d || d.dataset.mmUpcartWache) return;
    d.dataset.mmUpcartWache = '1';

    function pruefen() {
      var dlg = d.querySelector('dialog');
      var offen = d.hasAttribute('open') || (dlg && dlg.open);
      if (!offen || !upcartDa()) return;
      alteZu();
      upcartOeffnen();
    }

    if (window.MutationObserver) {
      new MutationObserver(pruefen).observe(d, {
        attributes: true, subtree: true, attributeFilter: ['open', 'class']
      });
    }
  }

  function start() {
    wache();
    /* Der Kopfbereich wird von Shopify-Sektionen neu gebaut - dann ist auch
       die Schublade neu und braucht die Wache erneut. */
    document.addEventListener('shopify:section:load', wache);
    var n = 0;
    var t = window.setInterval(function () {
      wache();
      if (++n > 20) window.clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
